import ApiService from "@/core/services/api.service";
import {GET_TICKET_CSVC} from "../csvc/csvc.module";

const _ = require('lodash');

export const CREATE_SALARY_MECHANISM = "create";
export const GET_SALARY_MECHANISMS = "get-salary-mechanisms";
export const EDIT_SALARY_MECHANISM = "edit-salary-mechanism";
export const GET_CANDIDATE_TYPE = "salary-mechanism/candidate-types";
export const DELETE_SALARY_MECHANISM = "delete-salary-mechanism";

const state = {};
const getters = {};

const actions = {
    [CREATE_SALARY_MECHANISM](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post('salary-mechanisms', payload).then(({data}) => {
                resolve(data);
            }).catch((response) => {
                reject(response)
            });
        })
    },

    [GET_SALARY_MECHANISMS](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query('salary-mechanisms', payload).then(({data}) => {
                resolve(data);
            }).catch((response) => {
                reject(response)
            });
        })
    },

    [EDIT_SALARY_MECHANISM](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.put(`salary-mechanisms/${payload.id}`, payload).then(({data}) => {
                resolve(data);
            }).catch((response) => {
                reject(response)
            });
        })
    },

    [GET_CANDIDATE_TYPE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${GET_CANDIDATE_TYPE}`, payload).then(({data}) => {
                resolve(data);
            }).catch((response) => {
                reject(response)
            });
        })
    },

    [DELETE_SALARY_MECHANISM](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`salary-mechanism/delete/${payload.id}`).then(({data}) => {
                resolve(data);
            }).catch((response) => {
                reject(response)
            });
        })
    },
};

const mutations = {};

export default {
    state,
    actions,
    mutations,
    getters
};